export var ActivityBetConditionType;
(function (ActivityBetConditionType) {
    ActivityBetConditionType["SINGLE"] = "single";
    ActivityBetConditionType["ACCUMULATED"] = "accumulated";
})(ActivityBetConditionType || (ActivityBetConditionType = {}));
export var ActivityDepositConditionType;
(function (ActivityDepositConditionType) {
    ActivityDepositConditionType["SINGLE"] = "single";
    ActivityDepositConditionType["ACCUMULATED"] = "accumulated";
})(ActivityDepositConditionType || (ActivityDepositConditionType = {}));
export var ActivityDurationType;
(function (ActivityDurationType) {
    ActivityDurationType["TODAY"] = "today";
    ActivityDurationType["YESTERDAY"] = "yesterday";
    ActivityDurationType["THIS_WEEK"] = "this_week";
    ActivityDurationType["LAST_WEEK"] = "last_week";
    ActivityDurationType["THIS_MONTH"] = "this_month";
    ActivityDurationType["LAST_MONTH"] = "last_month";
    ActivityDurationType["CUSTOM"] = "custom";
})(ActivityDurationType || (ActivityDurationType = {}));
export var ActivityGameDurationType;
(function (ActivityGameDurationType) {
    ActivityGameDurationType["GAME_DAY"] = "game_day";
    ActivityGameDurationType["GAME_WEEK"] = "game_week";
})(ActivityGameDurationType || (ActivityGameDurationType = {}));
export var ActivityModuleType;
(function (ActivityModuleType) {
    ActivityModuleType["NONE"] = "none";
    ActivityModuleType["SINGLE"] = "single";
    ActivityModuleType["GAME"] = "game";
})(ActivityModuleType || (ActivityModuleType = {}));
export var ActivityFrequencyType;
(function (ActivityFrequencyType) {
    ActivityFrequencyType["ONE_TIME"] = "one_time";
    ActivityFrequencyType["EVERYDAY"] = "everyday";
    ActivityFrequencyType["EVERY_WEEK"] = "every_week";
    ActivityFrequencyType["EVERY_MONTH"] = "every_month";
})(ActivityFrequencyType || (ActivityFrequencyType = {}));
export var ActivityConditionType;
(function (ActivityConditionType) {
    ActivityConditionType["DEPOSIT"] = "deposit";
    ActivityConditionType["BET"] = "bet";
})(ActivityConditionType || (ActivityConditionType = {}));
export var ActivityRequirementsType;
(function (ActivityRequirementsType) {
    ActivityRequirementsType["SINGLE"] = "single";
    ActivityRequirementsType["ACCUMULATED"] = "accumulated";
})(ActivityRequirementsType || (ActivityRequirementsType = {}));
//# sourceMappingURL=ActivityLayoutSetting.js.map